// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
export type TradePartnerSignatoryContactFragment = { __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, country: string, postalCode: string } | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export const TradePartnerSignatoryContactFragmentDoc = gql`
    fragment TradePartnerSignatoryContact on TradePartnerContact {
  ...Named
  title
  email
  officePhone
  mobilePhone
  address {
    id
    street1
    street2
    city
    state
    country
    postalCode
  }
  tradePartner {
    ...Named
  }
}
    ${NamedFragmentDoc}`;